import Octokit from '@octokit/rest'
import {START_PULLS_LOAD, SET_PULLS_RESULT, NETWORK_ERROR, UPDATE_CONFIG} from './types'
import {VERSION} from '../constants'

export const update_config = ({auth_token, owner, repo}) => (dispatch) => {
  dispatch({
    type: UPDATE_CONFIG,
    auth_token,
    owner,
    repo,
  })
}

export const load_pulls = ({auth_token, owner, repo}) => (dispatch) => {
  dispatch({type: START_PULLS_LOAD})

  const octokit = new Octokit({
    auth: auth_token,
    userAgent: VERSION,
  })

  octokit.pulls.list({owner, repo})
    .then((response) => {
      // console.info({pulls_response: response.data})
      dispatch({type: SET_PULLS_RESULT, pulls: response.data})
    }).catch((e) => {
      dispatch({type: NETWORK_ERROR, error: e})
    })
}
